 
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Card, DashboardCardResponse } from '@uptime-bff/api-contract';

export const defaultState: DashboardState = {
  isOpen: true,
  errorMessageText: '',
  doneEditing: false,
  showDeleteConfirmation: false,
  cardItems: [],
  backupCardItems: [],
  showCustomersInFocusSection: true,
};

interface DashboardState {
  backupCardItems: Card[];
  cardItems: Card[];
  errorMessageText: string;
  showDeleteConfirmation: boolean;
  doneEditing: boolean;
  isOpen: boolean;
  npsNextDisplayDate?: string;
  npsDismissedAt?: string;
  widgetList?: string[];
  isSorting?: boolean;
  showErrorBanner?: boolean;
  showCustomersInFocusSection: boolean;
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: defaultState,
  reducers: {
    setIsOpenMessageModal: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setCustomerWidgetsToBeDeleted: (state, action: PayloadAction<string[]>) => {
      state.widgetList = action.payload;
    },
    setOldCustomerWidgets: (state, action: PayloadAction<Card[]>) => {
      state.backupCardItems = action.payload;
    },
    setCustomerWidgets: (state, action: PayloadAction<Card[] | DashboardCardResponse[]>) => {
      state.cardItems = action.payload as Card[];
    },
    setIsSorting: (state, action: PayloadAction<boolean>) => {
      state.isSorting = action.payload;
    },
    setShowErrorBanner: (state, action: PayloadAction<boolean>) => {
      state.showErrorBanner = action.payload;
    },
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.errorMessageText = action.payload;
    },
    setDoneEditing: (state, action: PayloadAction<boolean>) => {
      state.doneEditing = action.payload;
    },
    setShowDeleteConfirmation: (state, action: PayloadAction<boolean>) => {
      state.showDeleteConfirmation = action.payload;
    },
    setShowCustomersInFocusSection(state, action: PayloadAction<boolean>) {
      state.showCustomersInFocusSection = action.payload;
    },
    setNpsNextDisplayDate(state, action: PayloadAction<string>) {
      state.npsNextDisplayDate = action.payload;
    },
    setNpsDismissed(state, action: PayloadAction<string>) {
      state.npsDismissedAt = action.payload;
    },
    clearNpsDismissed(state) {
      state.npsDismissedAt = undefined;
    }
  },
});

export const {
  setIsOpenMessageModal,
  setCustomerWidgetsToBeDeleted,
  setOldCustomerWidgets,
  setCustomerWidgets,
  setIsSorting,
  setShowErrorBanner,
  setErrorMessage,
  setDoneEditing,
  setShowDeleteConfirmation,
  setShowCustomersInFocusSection,
  setNpsNextDisplayDate,
  setNpsDismissed,
  clearNpsDismissed
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
